import React from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { Link } from 'react-router-dom';
import { formatAmount } from 'src/utils/formatAmout';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';
import getCardMovementStatusIcon from 'src/utils/card-movements';
import CardMovementStatus from 'src/utils/constants/card-movements';
import { formatCardLastFourDigits } from 'src/utils/cards';
import { useTranslation } from 'react-i18next';

const CardMovementsRow = ({ chargeId, client, card, invoiceAmount, commissionAmount, date, status }) => {
  const { t } = useTranslation();
  return (
    <TableRow hover>
      <TableCell align="center">
        <Link to={`/clients/detail/${client.id}`}>{client.name}</Link>
      </TableCell>
      <TableCell align="center">{chargeId}</TableCell>
      <TableCell align="center">
        {formatCardLastFourDigits(card.last4, t)}
      </TableCell>
      <TableCell align="center">{formatAmount(invoiceAmount)}</TableCell>
      <TableCell align="center">{formatAmount(commissionAmount)}</TableCell>
      <TableCell align="center">
        {selectFormatDate(date, dateFormatType.DAY)}
      </TableCell>
      <TableCell align="center">{getCardMovementStatusIcon(status)}</TableCell>
    </TableRow>
  );
};

CardMovementsRow.propTypes = {
  chargeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  client: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string
  }),
  card: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    brand: PropTypes.string,
    last4: PropTypes.string,
    bank: PropTypes.string
  }),
  invoiceAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  commissionAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  date: PropTypes.string,
  status: PropTypes.oneOf(Object.values(CardMovementStatus))
};

CardMovementsRow.defaultProps = {
  chargeId: null,
  client: null,
  card: null,
  invoiceAmount: 0,
  commissionAmount: 0,
  date: null,
  status: CardMovementStatus.PENDING
};

export default CardMovementsRow;
